class Faqs {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;
    this.init();
  }

  init() {
    this.accordions = this.element.querySelectorAll('details');
    this.accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        this.toggleAccordion(accordion);
      });
    });
  }

  toggleAccordion(element) {
    if (element.open) {
      this.accordions.forEach((accordion) => {
        if (accordion !== element) {
          accordion.open = false;
        }
      });
    }
  }
}

export default Faqs;
